import { styled, SxProps, Typography } from '@mui/material';
import { MouseEventHandler, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { WithTheme } from '@issuemanager/apps/client/theme';

const StyledTypography = styled(Typography)`
  cursor: pointer;
`;

interface Props {
  keys: string[];
  indexes: number[];
  actions: MouseEventHandler<HTMLDivElement>[];
  highlightSx?: WithTheme<SxProps>;
  sx?: WithTheme<SxProps>;
}

/**
 * @props keys: the order of the keys is the one to be displayed
 * @props actions: the position of the action must match with the indexes array
 */
export function TextWithActions(props: Props) {
  const { keys, indexes, actions, highlightSx, sx } = props;
  const { t } = useTranslation();

  const highlightedElements: ReactNode[] = keys.map((key, i) => {
    const fnIndex = indexes.indexOf(i);
    const action =
      fnIndex > -1 && actions.length > fnIndex ? actions[fnIndex] : null;
    if (action) {
      return (
        <StyledTypography key={key} onClick={action} sx={highlightSx}>
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          {t(key)}
        </StyledTypography>
      );
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return t(key) as string;
    }
  });

  return <Typography sx={sx}>{highlightedElements.map((e) => e)}</Typography>;
}
